export default (element: HTMLElement) => {
  const button = element.querySelector<HTMLElement>(
    '[data-component-role="toggle"]',
  );
  button?.addEventListener('click', () => {
    element.classList.toggle('header--open');
  });
};
